module.exports = __webpack_public_path__ + "img/SDG-15-EN-INVERTED.7fc601b5.png";